import { gql } from 'graphql-request'

export const GetSoldWoolSummaryGql = gql`
  query listSoldWoolSummary($stationRecordNumber: String!, $firstSeason: Int!) {
    listSoldWoolSummary(
      request: { stationRecordNumber: $stationRecordNumber, firstSeason: $firstSeason }
    ) {
      results {
        averageBaleWeight
        averageGrossPricePerKgExGST
        averageNetPricePerKgIncGST
        season
        totalBales
        totalGrossProceedsExGST
        totalKgs
        totalNetProceedsIncGST
      }
    }
  }
`
